// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"SimCardScreen_buttonsContainer__Ku1k8","button":"SimCardScreen_button__e8On5"};